import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import * as $ from 'jquery';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';

@Component({
  selector: 'app-workflow-state-modal',
  templateUrl: './workflow-state-modal.component.html',
  styleUrls: ['./workflow-state-modal.component.scss']
})
export class WorkflowStateModalComponent {
  workflowStateconfigForm: UntypedFormGroup;
  public Content: any;
  screencode: any;
  rowData: any;
  displayname: any;

  constructor(
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    public commonService: CommonService,
    public administrationSummarySerice:AdministrationSummaryService,

  ) {}

ngOnInit(){  
  
   this.workflowStateconfigForm = new UntypedFormGroup({
      ID:new UntypedFormControl(null),
      NAME: new UntypedFormControl(null),
      DISPLAY_NAME: new UntypedFormControl(null),
      IS_ACTIVE: new UntypedFormControl(true),
      RECORD_STATE: new UntypedFormControl(0),
  });
;
  this.viewState();

if(this.Content.ISFIXED)
{
  this.workflowStateconfigForm.controls["IS_ACTIVE"].disable();
}

if(this.Content.heading == "Edit")
{
  this.workflowStateconfigForm.controls["NAME"].disable();
}

}

viewState(){
  
  this.administrationSummarySerice.getRecord("api/state/getstatebyid/"+this.Content.id).subscribe((result)=>{
    this.workflowStateconfigForm.patchValue(result);
    if(this.workflowStateconfigForm.controls["RECORD_STATE"].value==1){
      this.workflowStateconfigForm.controls["IS_ACTIVE"].setValue(true);
     }
     else{
      this.workflowStateconfigForm.controls["IS_ACTIVE"].setValue(false);
     }
  });
  
}

save(){
  if (this.validateControls()) {
 
  var formData = this.workflowStateconfigForm.getRawValue();
   if(formData.IS_ACTIVE == true){
    formData.RECORD_STATE=1;
   }
   else{
    formData.RECORD_STATE=0;
   }
   switch(this.Content.screencode)
   {
      case "ist":
        formData["MODULE_ID"]="2";
       break
       case "eap":
        formData["MODULE_ID"]="5";
       break
       case "grants":
        formData["MODULE_ID"]="4";
       break
   }
   formData["ISFIXED"] = this.Content.ISFIXED;
    if(this.Content.heading == "Add"){
    formData["ID"] = this.Content.id;
    formData.NAME =formData.NAME==null?null:formData.NAME==undefined?undefined:formData.NAME.trim();
    formData.DISPLAY_NAME=formData.DISPLAY_NAME==null?null:formData.DISPLAY_NAME==undefined?undefined:
    formData.DISPLAY_NAME.trim();

    this.summaryService.Insert('api/state/insert', formData).subscribe(summary => {
        if(summary["Status"]===0){
        this.commonService.SuccessBanner(summary.Message);
        this.modalRef.close();
        }

        else{
          this.commonService.ValidationBanner(summary.Message);
          }
    });
    }

    else if(this.Content.heading == "Edit"){
      formData["ID"] = this.Content.id;
      formData.DISPLAY_NAME=formData.DISPLAY_NAME==null?null:formData.DISPLAY_NAME==undefined?undefined:
      formData.DISPLAY_NAME.trim();
      this.summaryService.Insert('api/state/update', formData).subscribe(summary => {
        if(summary["Status"]===0){
        this.commonService.SuccessBanner(summary.Message);
        
        this.modalRef.close();
        }

        else{
          this.commonService.ValidationBanner(summary.Message);
          }
    });
    }
  } 
}

validateControls(): boolean {
  let isValid = true;
  let message = "";
  const formData = this.workflowStateconfigForm.getRawValue();
;
  if (!this.Content.ISFIXED && (formData.NAME === null || formData.NAME === "" || formData.NAME === undefined)) {
    $("#NAME").addClass("ng-touched ng-invalid validate-error");
    $("#NAME").removeClass("ng-untouched ng-valid");
    message += "Please enter Name<br/>";
    isValid = false;
  }else if(!this.Content.ISFIXED && (formData.NAME !=null && formData.NAME != undefined)&&(formData.NAME.trim()=="")){
    $("#NAME").addClass("ng-touched ng-invalid validate-error");
    $("#NAME").removeClass("ng-untouched ng-valid");
    message += "Please enter Name<br/>";
    isValid = false;
  } 
  else {
    $("#NAME").addClass("ng-untouched ng-valid");
    $("#NAME").removeClass("ng-touched ng-invalid validate-error");
  }
if(this.Content.heading != 'Add')
{
  if((formData.DISPLAY_NAME ==null || formData.DISPLAY_NAME == undefined || formData.DISPLAY_NAME.trim() == "")){
    $("#NAME").addClass("ng-touched ng-invalid validate-error");
    $("#NAME").removeClass("ng-untouched ng-valid");
    message += "Please enter Display Name<br/>";
    isValid = false;
  } 
  else {
    $("#NAME").addClass("ng-untouched ng-valid");
    $("#NAME").removeClass("ng-touched ng-invalid validate-error");
  }
}

  if (!isValid) {
    this.commonService.ValidationBanner(message);
  } 
  return isValid;
}

ClosePopup() {
  //  this.action.next();
    this.modalRef.dismiss();
  }


  
  


}
